<template>
  <div>
    <h-section-header back="/coach-courses">
      Edit Course
    </h-section-header>
    <div class="card card--white">
      <div class="card card--container">
        <div>
          <h-input type="text" required label="Title" v-model="course.title" />
          <h-input type="text" label="Description" v-model="course.description" required/>
          <div class="small-top">
            <label class="small-top">Course Image</label>
            <div class="row">
              <div v-if="course.background_image" class="row" style="margin-right: 10px">
                <img :src="course.background_image" style="max-width: 100px; max-height: 100px; margin-right: 10px" />
                <h-icon class="clickable" @click="course.background_image = ''">delete</h-icon>
              </div>
              <h-file @upload="f => course.background_image = f" :base64="true" />
            </div>
            <h-input class="small-top" type="checkbox" :reverse="true" label="Make this available for all your clients" v-model="course.public" />
            <h-input class="small-top" type="checkbox" :reverse="true" label="Published" v-model="course.published" />
          </div>
        </div>

        <div class="card card--container" row align-right style="display: flex; align-items: right">
          <h-btn flat color="primary" @click="save">Save</h-btn>
          <h-btn flat color="red" style="align-items: right" class="right" @click="deleteCourseDialog = true">Delete Course</h-btn>
        </div>
      </div>
    </div>
    <h-section-header>
      <div class="row space-between align-center full-width">
        <div>Modules</div>
        <h-btn @click="$router.push({name: 'newModule', params: {course_id: course.id}})">Add Module</h-btn>
      </div>
    </h-section-header>
    <div class="card card--transparent small-top" v-for="(module, index) in modules" :key="module.id">
      <div class="card card--container row-space-between row">
        <div class="col">
          <h-icon class="clickable" :disabled="index == 0" @click="moveUp(index)">keyboard_arrow_up</h-icon>
          <h-icon class="clickable" :disabled="modules.length - 1 == index" @click="moveDown(index)">keyboard_arrow_down</h-icon>
        </div>
        <div class="clickable" @click="$router.push({name: 'editModule', params: {id: module.id}})">
          <h3>{{module.title}}</h3>
          <div>{{module.description}}</div>
        </div>
      </div>
    </div>

    <div v-if="!course.public">
      <h-section-header>
        <div class="row space-between align-center full-width">
          <div>Clients Given Access</div>
          <add-clients  @finished="addClientsToCourse"/>
        </div>
      </h-section-header>

      <div class="card-rows">
        <div v-for='client in client_courses' :key="client.id" class="card card--transparent card--relative">
          <h-icon class="close clickable" @click="deleteClientCourse(client)">close</h-icon>
          <div class="card--container">{{client.first_name}} {{client.last_name}}</div>
        </div>
      </div>
    </div>

    <modal v-if="deleteCourseDialog">
      <div class="card card--white">
        <div class="card--container">
          <h3>Are you sure? This action cannot be undone</h3>
          <h-btn @click.stop="deleteCourseDialog=false">Close</h-btn>
          <h-btn @click.stop="deleteCourseDialog=false; deleteCourse()">Delete</h-btn>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import User from "@/services/api/authUser";
import dataStore from "@/services/api/store";
import _ from "lodash";
import snackbarHub from "@/services/hubs/snackbar";
import axios from "axios";
import addClients from "../../components/clients/addClientModal";
import modal from "@/components/modal";
const COURSE_STORE = "CoachCourses";
const COURSE_MODULE_STORE = "CoachCourseModules";
const CLIENT_STORE = "CoachClients";
const CLIENT_COURSE_STORE = "CoachClientCourses";


export default {
  props: ["id"],
  data() {
    return {
      course: {
        background_img: undefined,
      },
      modules: [],
      displayError: "",
      userId: User.id,
      deleteCourseDialog: false,
      client_courses: [],
      addClientCourses: false,
    };
  },
  components: {
    modal,
    addClients
  },
  created() {
    dataStore.find(COURSE_STORE, this.id).then(result => {
      this.course = result;
    });

    dataStore
      .findAll(COURSE_MODULE_STORE, { course_id: this.id }, { force: true })
      .then(result => {
        this.modules = _.orderBy(result, "ordering");
      });

    dataStore
      .findAll(
      CLIENT_STORE,
      { clientcourses__course: this.id, limit: 1000 },
      { force: true }
      )
      .then(result => {
        this.client_courses = result;
      });
  },
  methods: {
    save() {
      this.course.save().then(() => {
        snackbarHub.update("Saved");
      });
    },
    deleteClientCourse(client) {
      snackbarHub.update("Revoking");
      axios
        .post(
        `${process.env.VUE_APP_API_URL}coaches/courses/${
        this.id
        }/remove_user/`,
        { user: client.id }
        )
        .then(() => {
          this.client_courses = this.client_courses.filter(
            c => c.id !== client.id
          );
          snackbarHub.update("Revoked");
        });
    },
    addClientsToCourse(clients) {
      console.log("this was called")
      Promise.all(
        clients.map(client => {
          return dataStore
            .create(CLIENT_COURSE_STORE, {
              client: client.id,
              course: this.id
            })
            .then(
            () => (this.client_courses = [client, ...this.client_courses])
            );
        })
      );
    },
    deleteCourse() {
      dataStore.destroy(COURSE_STORE, this.id);
      this.$router.push({ name: "courses" });
      snackbarHub.update("Deleted");
    },
    updateOrdering() {
      for (var i = 0; i < this.modules.length; i++) {
        var module = this.modules[i];
        if (i !== module.ordering) {
          module.ordering = i;
          dataStore.update(COURSE_MODULE_STORE, module.id, module);
        }
      }
      this.modules = _.orderBy(this.modules, "ordering");
      snackbarHub.update("Saved");
    },
    moveUp(index) {
      var t = this.modules[index];
      this.modules[index] = this.modules[index - 1];
      this.modules[index - 1] = t;
      this.updateOrdering();
    },
    moveDown(index) {
      var t = this.modules[index];
      this.modules[index] = this.modules[index + 1];
      this.modules[index + 1] = t;
      this.updateOrdering();
    }
  }
};
</script>

<style lang="less" scoped>

</style>
